<script>
  import Insert from '../../elements/Insert.svelte'
  import OpenBuyModalButton from '../../components/OpenBuyModalButton.svelte'

  export let insert_position
  export let inbetween_counter

</script>

{#if insert_position === 'before_previews'}
  <Insert {insert_position}>
    <span slot="toptitle">
      SUPPORT WORDMARK
    </span>
    <span slot="title">
      Is Wordmark helping with your work?
    </span>
    <span slot="text">
      Support its development and maintenance by using Wordmark Pro.<br>
      Plus, it will unlock all the time saving features.
    </span>
    <span slot="button">
      <OpenBuyModalButton feature='support'>Upgrade to Wordmark Pro</OpenBuyModalButton> 
    </span>
  </Insert>
{/if}

{#if insert_position === 'between_previews'}
  {#if inbetween_counter=== 2}
    <Insert {insert_position}>
      <span slot="toptitle">
        SUPPORT WORDMARK
      </span>
      <span slot="title">
        Help Wordmark stay free
      </span>
      <span slot="text">
        Wordmark have been serving designers and crafters all around the world for 11 years<br>
        <small>
          If you choose to purchase a Pro Account, you are not only supporting the service you like, but also helping everyone else who wouldn't be able to afford this if it wasn't for free.
        </small>
      </span>
      <span slot="button">
        <OpenBuyModalButton feature='support'>Upgrade to Wordmark Pro</OpenBuyModalButton> 
      </span>
    </Insert>
  {/if}
{/if}